import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const deletePotentialChannels = async (channelId) => {
  return await axios.delete(`potential-sensors/channels/${channelId}`)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default deletePotentialChannels;